import * as API_Common from '@/api/common.js'

/**
 * 表单页加载耗时埋点 mixin
 *
 * 通过 formPageBuriedMixin 引入，或页面直接 mixins 引入。
 *
 * 上报两个事件（均从 created 记录 pageOpenTime 起算）：
 * - 100076：页面打开 → mounted 后首屏 DOM 渲染完成（不含接口）
 * - 100077：页面打开 → getUserDetail 返回且回显 DOM 更新完成（remark：耗时&是否老用户）
 *
 * getUserDetail 请使用 getUserDetailOldWithTrack，勿直接调 API_Common.getUserDetailOld。
 */
export default {
  created() {
    // 页面打开时刻，作为 100076 / 100077 的共同起点
    this.pageOpenTime = Date.now()
  },
  mounted() {
    // 首屏模板渲染完成后上报 100076
    this.$nextTick(() => {
      this.trackPageLoadDuration()
    })
  },
  methods: {
    /**
     * 带埋点的用户详情回显请求。
     * finally 在页面 .then/.catch 处理完接口数据后执行，再 $nextTick 等待回显渲染。
     */
    getUserDetailOldWithTrack(channelCode) {
      this._userDetailIsOldUser = false
      this._userDetailTrackUserId = ''
      return API_Common.getUserDetailOld(channelCode)
        .then((res) => {
          if (res && res.code == 200 && res.data) {
            const data = res.data
            if (data.idCard) {
              this._userDetailIsOldUser = true
            }
            if (data.userId != null && data.userId !== '' && String(data.userId) !== 'null') {
              this._userDetailTrackUserId = String(data.userId)
            }
          }
          return res
        })
        .finally(() => {
          this.afterUserDetailHandled()
        })
    },
    /** 解析埋点 userId，过滤 null / 'null' / 空值 */
    resolveTrackUserId(preferredUserId) {
      const candidates = [preferredUserId, this.userId, localStorage.getItem('userId')]
      for (let i = 0; i < candidates.length; i++) {
        const id = candidates[i]
        if (id != null && id !== '' && String(id) !== 'null' && String(id) !== 'undefined') {
          return String(id)
        }
      }
      return ''
    },
    /** 100076：首屏渲染耗时（仅上报一次） */
    trackPageLoadDuration() {
      if (this._pageLoadTrackReported) return
      this._pageLoadTrackReported = true
      const duration = Date.now() - (this.pageOpenTime || Date.now())
      const trackContext = { remark: duration }
      const userId = this.resolveTrackUserId()
      if (userId) trackContext.userId = userId
      API_Common.handleBatchTrackBase(100076, trackContext)
    },
    /** 接口数据处理完毕后，等 Vue 更新 DOM 再上报 100077 */
    afterUserDetailHandled() {
      this.$nextTick(() => {
        this.trackUserDetailRenderDuration()
      })
    },
    /** 100077：getUserDetail 返回并渲染完成耗时（仅上报一次）；remark 为「耗时&是否老用户」 */
    trackUserDetailRenderDuration() {
      if (this._userDetailTrackReported) return
      this._userDetailTrackReported = true
      const duration = Date.now() - (this.pageOpenTime || Date.now())
      const oldUserTag = this._userDetailIsOldUser ? '是老用户' : ''
      const trackContext = { remark: `${duration}&${oldUserTag}` }
      const userId = this.resolveTrackUserId(this._userDetailTrackUserId)
      if (userId) trackContext.userId = userId
      API_Common.handleBatchTrackBase(100077, trackContext)
    },
  },
}
